import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NavFooter({ user, onSignOut, onNewToken }) {
  const [changing, setChanging] = useState(false);
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [exporting, setExporting] = useState(false);
  const [pdfBusy, setPdfBusy] = useState(false);

  const exportPdf = async () => {
    setPdfBusy(true);
    try {
      const res = await axios.get(`${API}/binder-pdf`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `ECH_audit_binder_${new Date().toISOString().slice(0, 10)}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success("Audit binder PDF generated — cover, contents, every register");
    } catch {
      toast.error("PDF export failed");
    }
    setPdfBusy(false);
  };

  const exportBinder = async () => {
    setExporting(true);
    try {
      const res = await axios.get(`${API}/binder-export`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `ECH_binder_${new Date().toISOString().slice(0, 10)}.zip`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success("Records binder exported — file the dated ZIP per Appendix A-7");
    } catch {
      toast.error("Export failed");
    }
    setExporting(false);
  };

  const changePassword = async () => {
    try {
      const res = await axios.post(`${API}/auth/change`, { current_password: current, new_password: next });
      onNewToken(res.data.token, res.data.user);
      toast.success("Password changed — your other devices are signed out");
      setChanging(false); setCurrent(""); setNext("");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Change failed");
    }
  };

  return (
    <div className="nav-footer">
      {user && (
        <div className="nf-user" data-testid="signed-in-as">
          Signed in as <b>{user.name}</b><br />{user.email}
        </div>
      )}
      <button className="nf-btn" onClick={exportPdf} disabled={pdfBusy} data-testid="binder-pdf-btn">
        ⎙ {pdfBusy ? "Building…" : "Audit Binder (PDF)"}
      </button>
      <button className="nf-btn" onClick={exportBinder} disabled={exporting} data-testid="binder-export-btn">
        ⭳ {exporting ? "Exporting…" : "Binder Export (ZIP)"}
      </button>
      {!changing ? (
        <button className="nf-link" onClick={() => setChanging(true)} data-testid="change-password-toggle">Change my password…</button>
      ) : (
        <div className="nf-change">
          <input className="pp-name" type="password" placeholder="Current password" value={current} onChange={(e) => setCurrent(e.target.value)} data-testid="change-current" />
          <input className="pp-name" type="password" placeholder="New password (min 6)" value={next} onChange={(e) => setNext(e.target.value)} data-testid="change-new" />
          <div className="vr-btnrow">
            <button className="nf-btn" onClick={changePassword} disabled={!current || next.length < 6} data-testid="change-save">Save</button>
            <button className="nf-link" onClick={() => setChanging(false)}>Cancel</button>
          </div>
        </div>
      )}
      <button className="nf-link" onClick={onSignOut} data-testid="sign-out-btn">Sign out</button>
    </div>
  );
}
